import React from "react";
import { Link } from "react-router-dom";
import { FaFlask, FaChevronRight } from "react-icons/fa";

export default function IngredientCard({ item, isLastItem, lastItemRef }) {
    return (
        <Link
            ref={isLastItem ? lastItemRef : null}
            to={`/ingredients/${item.uri}`}
            className="overflow-hidden transition-all duration-200 border bg-white/40 backdrop-blur-sm border-white/60 group rounded-xl hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-emerald-600/30"
        >
            <div className="flex p-3">
                <div className="flex-shrink-0 mr-3">
                    <div className="flex items-center justify-center transition-colors rounded-full w-9 h-9 bg-emerald-300/20 text-emerald-600 group-hover:bg-emerald-100">
                        <FaFlask className="size-3.5" />
                    </div>
                </div>
                <div className="flex-1 min-w-0">
                    <div className="font-medium transition-colors text-15 text-secondary group-hover:text-emerald-700">
                        {item.name.replace("&amp;", "&")}
                    </div>
                    <div className="text-12 text-secondary/60">
                        Active Ingredient
                    </div>
                </div>

                <div className="self-center ml-2 -mr-1 transition-transform transform group-hover:translate-x-1">
                    <div className="p-1 rounded-full text-secondary/40 group-hover:text-emerald-600">
                        <FaChevronRight className="size-3" />
                    </div>
                </div>
            </div>
        </Link>
    );
}